import { render } from "./Styleguide-Layout.vue?vue&type=template&id=ab4c8088"
import script from "./Styleguide-Layout.vue?vue&type=script&lang=js"
export * from "./Styleguide-Layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__